import { ReportTypeEnum } from '@revelio/data-access';

import type { UnifiedReport } from '../hooks/use-all-reports';

/**
 * Controls disabling reruns of reports. Entries that come first are checked first.
 */
export const disabledReportReruns = (report: UnifiedReport): string | null => {
  const disabledConditions = [
    // Report builder v3 role taxonomy release
    (report: UnifiedReport) => {
      if (!report?.createdAt) return null;
      // when report builder v3 taxonomy was released: https://reveliolabs.slack.com/archives/C02LH4QA19S/p1749811072766089
      const disabledBeforeDate = new Date('2025-06-13T11:00:00Z');
      const reportCreatedDate = new Date(report?.createdAt);
      if (reportCreatedDate < disabledBeforeDate) {
        return 'This previously run report is incompatible with improvements to job taxonomy and cannot be regenerated.';
      }
      return null;
    },
    // Report builder v3 skills taxonomy release
    (report: UnifiedReport) => {
      if (report?.reportType === ReportTypeEnum.MarketTightness) {
        const disabledBeforeDate = new Date('2025-09-18T11:00:00Z');
        const reportCreatedDate = new Date(report?.createdAt);
        if (reportCreatedDate < disabledBeforeDate) {
          return 'This previously run report is incompatible with improvements to skills taxonomy and cannot be regenerated.';
        }
      }
      return null;
    },
  ];

  for (const condition of disabledConditions) {
    const result = condition(report);
    if (result) return result;
  }

  return null;
};
